import { Component, OnInit } from '@angular/core';
import { CMSContentService } from '../../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-menu-hamburger',
  templateUrl: './menu-hamburger.component.html',
  styleUrls: ['./menu-hamburger.component.scss']
})
export class MenuHamburgerComponent implements OnInit {
  public menuHamburger = [];

  constructor(private cmsContentService: CMSContentService) {}

  ngOnInit() {
    this.cmsContentService.getMenuHamburger().subscribe(response => {
      this.menuHamburger = response;
    });
  }

  public closeMenu() {
    const element = document.getElementById('checkbox');
    element['checked'] = false;
  }

  public openModal(id) {
    this.cmsContentService.openModal(id);
    this.closeMenu();
  }

  public openExternalUrl() {
    window.open("https://facgeofuncesp.facilinformatica.com.br/", "_blank");
    this.closeMenu();
  }
}
